<template>
    <div class="footer"> 
      <v-container>
        <v-col cols="12">
          <v-row align="center" class="white--text">
            &copy;
            <strong class="mx-1">Nearguide</strong>
            -
            {{ new Date().getFullYear() }}
            <v-spacer></v-spacer>
            <div v-for="(icon,index) in icons" :key="index">
              <v-btn v-if="icon.visible" class="mx-4" dark icon>
                <v-icon size="24px">{{ icon.icon }}</v-icon>
              </v-btn>
            </div>
          </v-row>
        </v-col>
      </v-container>
    </div>
</template>

<script>
import { getLangValue } from "@/globalFunctions.js";
export default {
  name: "ComponentNavBar",
  props:['fixed'],
  methods: {
    putTitulos: async function() {
      var socialFB = await getLangValue("Social", "Facebook", "pt");
      var socialTW = await getLangValue("Social", "Twitter", "pt");

      var socialLinkedin = await getLangValue("Social", "Linkedin", "pt");

      var socialInstagram = await getLangValue("Social", "Instagram", "pt");

      this.social.push(socialFB);
      this.social.push(socialTW);
      this.social.push(socialLinkedin);
      this.social.push(socialInstagram);
    },
    async socialCheck() {
      this.icons.map((icon, index) => {
        if (this.social[index] != "") {
          icon.visible = true;
        }
      });
    }
  },
  async mounted() {
    await this.putTitulos();
    await this.socialCheck();
  },
  data: () => ({
    social: [],
    icons: [
      { icon: "mdi-facebook", visible: false },
      { icon: "mdi-twitter", visible: false },
      { icon: "mdi-linkedin", visible: false },
      { icon: "mdi-instagram", visible: false }
    ]
  })
};
</script>